import { render, staticRenderFns } from "./BigNumberSettings.vue?vue&type=template&id=4adceec0&scoped=true&"
import script from "./BigNumberSettings.vue?vue&type=script&lang=js&"
export * from "./BigNumberSettings.vue?vue&type=script&lang=js&"
import style0 from "./BigNumberSettings.vue?vue&type=style&index=0&id=4adceec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adceec0",
  null
  
)

export default component.exports